<template>
  <CategoryTop :title="$t('contactService.title')" :breadcrumbs-parent-routes="breadcrumbsParentRoutes"
    :description="$t('contactService.description')" />
</template>

<script setup>
import CategoryTop from "../../General/CategoryTop/index.vue";
import { computed } from "vue";
import { useTenantConfig } from "@/composables/useTenantConfig";
const { tenantConfig } = useTenantConfig();
const breadcrumbsParentRoutes = computed(() =>
  (tenantConfig.value?.serviceNumberBreadcrumbsParentRoutes ?? [])
);
</script>
